// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-header,
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-tool-header,
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-related-header, .headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content, .headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-header .cald_help-tab-header-option, .headerDiv .header-right-block .cald_head_name, .headerDiv .header-right-block .cald_user-menu .secondary-icon-btn em {
  font-family: "72-Regular";
}

/* Device breakpoints */
.headerDiv {
  height: 4.8rem;
  box-sizing: border-box;
}
.headerDiv .dd-slider-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 4.8rem;
  width: 100%;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.6);
}
.headerDiv .dd-slider-overlay .slider-cald {
  background-color: #ffffff;
  box-shadow: -0.2rem 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.15);
  top: 4.8rem;
  bottom: 0;
  position: fixed;
  right: 0;
  width: 49rem;
}
.headerDiv .header-right-block {
  padding: 1.2rem 0.8rem 1.2rem 1.6rem;
}
.headerDiv .header-right-block .searchbar-container,
.headerDiv .header-right-block .full-screen-toggle,
.headerDiv .header-right-block .cald_user-menu,
.headerDiv .header-right-block .help-container,
.headerDiv .header-right-block .bookmark-container,
.headerDiv .header-right-block .recent-container {
  padding-right: 1rem;
}
.headerDiv .header-right-block .searchbar-container .secondary-icon-btn,
.headerDiv .header-right-block .full-screen-toggle .secondary-icon-btn,
.headerDiv .header-right-block .cald_user-menu .secondary-icon-btn,
.headerDiv .header-right-block .help-container .secondary-icon-btn,
.headerDiv .header-right-block .bookmark-container .secondary-icon-btn,
.headerDiv .header-right-block .recent-container .secondary-icon-btn {
  color: #d1e3ff;
}
.headerDiv .header-right-block .searchbar-container .secondary-icon-btn:hover,
.headerDiv .header-right-block .full-screen-toggle .secondary-icon-btn:hover,
.headerDiv .header-right-block .cald_user-menu .secondary-icon-btn:hover,
.headerDiv .header-right-block .help-container .secondary-icon-btn:hover,
.headerDiv .header-right-block .bookmark-container .secondary-icon-btn:hover,
.headerDiv .header-right-block .recent-container .secondary-icon-btn:hover {
  background-color: #485b6e;
  color: #d1e3ff;
}
.headerDiv .header-right-block .searchbar-container .secondary-icon-btn:focus, .headerDiv .header-right-block .searchbar-container .secondary-icon-btn:active,
.headerDiv .header-right-block .full-screen-toggle .secondary-icon-btn:focus,
.headerDiv .header-right-block .full-screen-toggle .secondary-icon-btn:active,
.headerDiv .header-right-block .cald_user-menu .secondary-icon-btn:focus,
.headerDiv .header-right-block .cald_user-menu .secondary-icon-btn:active,
.headerDiv .header-right-block .help-container .secondary-icon-btn:focus,
.headerDiv .header-right-block .help-container .secondary-icon-btn:active,
.headerDiv .header-right-block .bookmark-container .secondary-icon-btn:focus,
.headerDiv .header-right-block .bookmark-container .secondary-icon-btn:active,
.headerDiv .header-right-block .recent-container .secondary-icon-btn:focus,
.headerDiv .header-right-block .recent-container .secondary-icon-btn:active {
  background-color: #919ba7;
  color: #d1e3ff;
}
.headerDiv .header-right-block .full-screen-toggle .selected,
.headerDiv .header-right-block .help-container .selected,
.headerDiv .header-right-block .bookmark-container .selected,
.headerDiv .header-right-block .recent-container .selected {
  background-color: #919ba7;
}
.headerDiv .header-right-block .cald_user-menu .secondary-icon-btn {
  font-size: 1rem;
}
.headerDiv .header-right-block .cald_user-menu .secondary-icon-btn em {
  display: inline-block;
  border: 1px solid #d1e3ff;
  border-radius: 50%;
  height: 2.3rem;
  width: 2.3rem;
  text-align: center;
  line-height: 2.1rem;
  font-style: normal;
}
.headerDiv .header-right-block .cald_user-menu .secondary-icon-btn em:before {
  font-size: 1rem;
}
.headerDiv .header-right-block .cald_user-menu.open .dropdown-toggle {
  background-color: #919ba7;
  outline: none;
}
.headerDiv .header-right-block .cald_right {
  float: right;
  padding: 2rem;
}
.headerDiv .header-right-block .cald_head_name {
  font-size: 1.4rem;
  color: #9b9b9b;
}
.headerDiv .cald_header-help-options {
  left: -46rem;
  width: 50rem;
  top: 3.7rem;
  box-shadow: 0 2px 4px 0 rgba(51, 51, 51, 0.2);
  border: none;
}
.headerDiv .cald_header-help-options::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  left: 48.7rem;
  top: 0px;
  box-sizing: border-box;
  border: 8px solid #fff;
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(51, 51, 51, 0.03);
}
.headerDiv .cald_header-help-options .cald_user-help-option {
  width: 100%;
  height: 100%;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-header {
  height: 3.2rem;
  border-bottom: 0.1rem solid #e5e5e5;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-header .cald_help-tab-header-option {
  font-size: 1.4rem;
  text-align: center;
  color: #6a6d70;
  display: inline-block;
  margin: 1rem 2rem;
  cursor: pointer;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-header .cald_help-tab-header-option-sel {
  color: #0a6ed1;
  border-bottom: 0.2rem solid #0a6ed1;
  cursor: default;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content {
  padding: 1rem 2rem;
  font-size: 1.4rem;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-header,
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-tool-header,
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-related-header {
  color: #32363a;
  padding: 1rem 0rem;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-content {
  color: #515559;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-tool-container .cald_page-help-tool-content .cald_page-help-tool-item {
  cursor: pointer;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-tool-container .cald_page-help-tool-content .cald_page-help-tool-item .cald_page-help-tool-icon {
  color: #0a6ed1;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-tool-container .cald_page-help-tool-content .cald_page-help-tool-item .cald_page-help-tool-label {
  color: #515559;
  padding: 0rem 1rem;
}
.headerDiv .cald_header-help-options .cald_user-help-option .cald_help-tab-content .cald_page-help-related-container .cald_page-help-related-content .cald_page-help-related-link {
  color: #0a6ed1;
  padding: 0.4rem 0rem;
  display: inline-block;
  cursor: pointer;
}
.headerDiv .cald_user-profile-option-mask-bar {
  width: 2.8rem;
  height: 2.8rem;
  background-color: #3b4b5b;
  border: solid 1px #ffffff;
  border-radius: 50%;
  display: inline-block;
  margin: -0.1rem 1rem;
}
.headerDiv .cald_user-profile-option-mask-bar .cald_user-profile-option-mask-text-bar {
  width: 100%;
  color: #fff;
  font-size: 1.4rem;
  font-weight: 300;
  text-align: center;
  height: 100%;
  display: inline-block;
  line-height: 2.6rem;
}
.headerDiv .cald_header-dropdown-options {
  right: 1.2rem !important;
  left: auto !important;
  top: 3.5rem !important;
}
.headerDiv .cald_header-dropdown-options.cc-menu-arrow {
  top: 1rem;
}
.headerDiv .cald_header-dropdown-options .cald_user-profile-option {
  color: blue !important;
  background-color: #fafafa;
  cursor: pointer;
  padding: 0.7rem 1.6rem;
}
.headerDiv .cald_header-dropdown-options .cald_user-profile-option .cald_user-profile-option-mask {
  width: 4.8rem;
  height: 4.8rem;
  background-color: #3b4b5b;
  border: solid 1px #ffffff;
  border-radius: 50%;
  display: inline-block;
  margin-right: 1.2rem;
}
.headerDiv .cald_header-dropdown-options .cald_user-profile-option .cald_user-profile-option-mask .cald_user-profile-option-mask-text {
  width: 100%;
  color: #fff;
  font-size: 1.8rem;
  font-weight: 300;
  text-align: center;
  height: 100%;
  display: inline-block;
  line-height: 4.8rem;
}
.headerDiv .cald_header-dropdown-options .cald_user-profile-option .cald_user-profile-option-name {
  display: inline-block;
  width: 18rem;
  position: absolute;
  top: 1.4rem;
}
.headerDiv .cald_header-dropdown-options .cald_user-profile-option .cald_user-profile-option-name .cald_user-profile-option-name-text {
  width: 100%;
  font-size: 1.8rem;
  font-weight: 300;
  color: #32363a;
}
.headerDiv .cald_header-dropdown-options .cald_user-profile-option .cald_user-profile-option-name .cald_user-profile-option-name-group {
  width: 100%;
  font-size: 1rem;
  color: #6f7275;
}
.headerDiv .cald_header-dropdown-options .cald_user-menu-option {
  font-size: 1.4rem;
  color: #515559;
  padding: 0.7rem 2rem;
}
.headerDiv .cald_header-dropdown-options .cald_user-menu-option .cald_user-menu-option-option-text {
  cursor: pointer;
}
.headerDiv .cald_header-dropdown-options .cald_user-menu-option-option {
  border-top: #e5e5e5 0.1rem solid;
}
.headerDiv .cald_header-dropdown-options .cald_user-menu-option-option .cald_logout-btn {
  margin: 0.5rem;
  background-color: #0a6ed1;
  border: 0.1rem solid #367db8;
}
.headerDiv .cald_header-dropdown-options .cald_logout-option {
  font-size: 1.4rem;
  color: #333333;
  padding-left: 2rem;
  padding-top: 0.7rem;
}
.headerDiv .cald_header-dropdown-options .cald_logout-option .cald_logout-option-text {
  cursor: pointer;
}
.headerDiv .searchbar-container {
  display: inline-block;
  position: relative;
}
.headerDiv .searchbar-container .divExpandSearch {
  position: absolute;
  right: 1rem;
  top: -0.7rem;
}
.headerDiv .searchbar-container .expandedCls {
  display: inline-block;
  width: 30rem;
}
.headerDiv .fa-th:before {
  content: "\\f00a";
  margin-right: 0.8rem;
}
.headerDiv .cald_left {
  float: left;
  padding: 2.5rem 0rem 2rem 2rem;
}
.headerDiv .caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.2rem;
  vertical-align: middle;
  border-top: 0.4rem dashed;
  border-top: 0.4rem solid;
  border-right: 0.4rem solid transparent;
  border-left: 0.4rem solid transparent;
}
.headerDiv .cald_logo-container .cald_header-name-label-container {
  display: inline-block;
  color: #32363a;
  font-size: 1.4rem;
  position: absolute;
  top: 1.6rem;
  left: 6.1rem;
}
.headerDiv .cald_header-toggle-container {
  height: 100%;
  text-align: left;
  padding: 1.3rem 1rem 1rem;
}
@media (min-width: 768px) {
  .headerDiv .cald_header-toggle-container {
    max-width: 3rem;
  }
}
.headerDiv .cald_header-toggle-container .cald_side-menu-icon {
  height: 2.6rem;
  width: 3.2rem;
  padding: 1rem 0.5rem 0.5rem;
  cursor: pointer;
  color: #d1e3ff;
}
.headerDiv .cald_header-toggle-container .cald_side-menu-icon:hover {
  border-radius: 0.4rem;
  background-color: #485b6e;
}
.headerDiv .cald_header-toggle-container .cald_side-menu-icon:before {
  font-size: 1.8rem;
}
.headerDiv .logo-icon {
  background-color: transparent;
  background-image: url('vw_header_icon_white.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 4.8rem;
  width: 10rem;
  display: inline-block;
  margin-left: 1rem;
}
.headerDiv .logo-icon:focus {
  outline: none !important;
}
.headerDiv .cald_lang-dropdown {
  width: 10rem;
  display: inline-block;
}
.headerDiv .cald_logout {
  padding-left: 1rem;
  cursor: pointer;
}

app-distributor-search .common-distributor-search .side-margin-left {
  margin: 0 !important;
}

.strip {
  height: 0.4rem;
  background-color: #e4e8f0;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/header/header.component.scss","webpack://./src/app/assets/css/cc_responsive-utilities.scss","webpack://./src/app/assets/css/_variables.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;;;EACI,yBAAA;ACrBJ;;ACLA,uBAAA;ADGA;EACE,cAAA;EACA,sBAAA;AAMF;AAJE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,0CAAA;EACA,wCAAA;AAMJ;AALI;EACE,yBAAA;EACA,uDAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;AAON;AAHE;EACE,oCAAA;AAKJ;AAJI;;;;;;EAME,mBAAA;AAMN;AALM;;;;;;EACE,cETW;AFqBnB;AAXQ;;;;;;EACE,yBEVU;EFWV,cEZS;AF8BnB;AAhBQ;;;;;;;;;;;EAEE,yBEdgB;EFehB,cEjBS;AF4CnB;AAnBM;;;;EACE,yBExBkB;AFgD1B;AAnBM;EACE,eAAA;AAqBR;AApBQ;EAEE,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAqBV;AApBU;EACE,eAAA;AAsBZ;AAjBQ;EACE,yBEhDgB;EFiDhB,aAAA;AAmBV;AAfI;EACE,YAAA;EACA,aAAA;AAiBN;AAfI;EACE,iBAAA;EAEA,cAAA;AAgBN;AAZE;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,6CAAA;EACA,YAAA;AAcJ;AAbI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;EACA,sBAAA;EACA,+CAAA;EAEA,qBAAA;EAEA,yBAAA;EACA,iDAAA;AAeN;AAbI;EACE,WAAA;EACA,YAAA;AAeN;AAdM;EACE,cAAA;EACA,mCAAA;AAgBR;AAfQ;EACE,iBAAA;EAEA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;AAgBV;AAdQ;EACE,cAAA;EACA,mCAAA;EACA,eAAA;AAgBV;AAbM;EACE,kBAAA;EACA,iBAAA;AAeR;AAbQ;;;EAIE,cAAA;EACA,kBAAA;AAcV;AAZQ;EACE,cAAA;AAcV;AAVY;EACE,eAAA;AAYd;AAXc;EACE,cAAA;AAahB;AAXc;EACE,cAAA;EACA,kBAAA;AAahB;AANY;EACE,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;AAQd;AAAE;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;AAEJ;AADI;EACE,WAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAGN;AACE;EACE,wBAAA;EACA,qBAAA;EACA,sBAAA;AACJ;AAAI;EACE,SAAA;AAEN;AAAI;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;AAEN;AADM;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;AAGR;AAFQ;EACE,WAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAIV;AADM;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAGR;AAFQ;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAIV;AAFQ;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAIV;AAAI;EACE,iBAAA;EACA,cAAA;EACA,oBAAA;AAEN;AADM;EACE,eAAA;AAGR;AAAI;EACE,gCAAA;AAEN;AADM;EACE,cAAA;EACA,yBAAA;EACA,4BAAA;AAGR;AAAI;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAEN;AADM;EACE,eAAA;AAGR;AAEE;EACE,qBAAA;EACA,kBAAA;AAAJ;AACI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACN;AACI;EACE,qBAAA;EACA,YAAA;AACN;AAGE;EACE,gBAAA;EACA,oBAAA;AADJ;AAIE;EACE,WAAA;EACA,8BAAA;AAFJ;AAKE;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,sCAAA;EACA,qCAAA;AAHJ;AAOI;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AALN;AASE;EACE,YAAA;EACA,gBAAA;EACA,yBAAA;AAPJ;AAQI;EAJF;IAKI,eAAA;EALJ;AACF;AAMI;EACE,cAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;EACA,cElTa;AF8SnB;AAKM;EACE,qBAAA;EACA,yBAAA;AAHR;AAMI;EACE,iBAAA;AAJN;AAQE;EACE,6BAAA;EACA,iDAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AANJ;AASE;EACE,wBAAA;AAPJ;AAUE;EACE,YAAA;EACA,qBAAA;AARJ;AAWE;EACE,kBAAA;EACA,eAAA;AATJ;;AAeI;EACE,oBAAA;AAZN;;AAiBA;EACE,cAAA;EACA,yBAAA;AAdF","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n@import '../../assets/css/cc_responsive-utilities';\n\n.headerDiv {\n  height: 4.8rem;\n  box-sizing: border-box;\n\n  .dd-slider-overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    top: 4.8rem;\n    width: 100%;\n    z-index: 10;\n    background-color: rgba(255, 255, 255, 0.6);\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.6);\n    .slider-cald {\n      background-color: #ffffff;\n      box-shadow: -0.2rem 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.15);\n      top: 4.8rem;\n      bottom: 0;\n      position: fixed;\n      right: 0;\n      width: 49rem;\n    }\n  }\n\n  .header-right-block {\n    padding: 1.2rem 0.8rem 1.2rem 1.6rem;\n    .searchbar-container,\n    .full-screen-toggle,\n    .cald_user-menu,\n    .help-container,\n    .bookmark-container,\n    .recent-container {\n      padding-right: 1rem;\n      .secondary-icon-btn {\n        color: $shell-icon-color;\n        &:hover {\n          background-color: $shell-hover-color;\n          color: $shell-icon-color;\n        }\n        &:focus,\n        &:active {\n          background-color: $shell-icon-active-color;\n          color: $shell-icon-color;\n        }\n      }\n    }\n    .full-screen-toggle,\n    .help-container,\n    .bookmark-container,\n    .recent-container {\n      .selected {\n        background-color: $shell-icon-active-color;\n      }\n    }\n\n    .cald_user-menu {\n      .secondary-icon-btn {\n        font-size: 1rem;\n        em {\n          @extend %font-regular;\n          display: inline-block;\n          border: 1px solid #d1e3ff;\n          border-radius: 50%;\n          height: 2.3rem;\n          width: 2.3rem;\n          text-align: center;\n          line-height: 2.1rem;\n          font-style: normal;\n          &:before {\n            font-size: 1rem;\n          }\n        }\n      }\n      &.open {\n        .dropdown-toggle {\n          background-color: $shell-icon-active-color;\n          outline: none;\n        }\n      }\n    }\n    .cald_right {\n      float: right;\n      padding: 2rem;\n    }\n    .cald_head_name {\n      font-size: 1.4rem;\n      @extend %font-regular;\n      color: #9b9b9b;\n    }\n  }\n\n  .cald_header-help-options {\n    left: -46rem;\n    width: 50rem;\n    top: 3.7rem;\n    box-shadow: 0 2px 4px 0 rgba(51, 51, 51, 0.2);\n    border: none;\n    &::after {\n      content: '';\n      position: absolute;\n      width: 0;\n      height: 0;\n      left: 48.7rem;\n      top: 0px;\n      box-sizing: border-box;\n      border: 8px solid #fff;\n      border-color: transparent transparent #fff #fff;\n      -webkit-transform-origin: 0 0;\n      transform-origin: 0 0;\n      -webkit-transform: rotate(135deg);\n      transform: rotate(135deg);\n      box-shadow: -1px 1px 1px 0 rgba(51, 51, 51, 0.03);\n    }\n    .cald_user-help-option {\n      width: 100%;\n      height: 100%;\n      .cald_help-tab-header {\n        height: 3.2rem;\n        border-bottom: 0.1rem solid #e5e5e5;\n        .cald_help-tab-header-option {\n          font-size: 1.4rem;\n          @extend %font-regular;\n          text-align: center;\n          color: #6a6d70;\n          display: inline-block;\n          margin: 1rem 2rem;\n          cursor: pointer;\n        }\n        .cald_help-tab-header-option-sel {\n          color: #0a6ed1;\n          border-bottom: 0.2rem solid #0a6ed1;\n          cursor: default;\n        }\n      }\n      .cald_help-tab-content {\n        padding: 1rem 2rem;\n        font-size: 1.4rem;\n        @extend %font-regular;\n        .cald_page-help-header,\n        .cald_page-help-tool-header,\n        .cald_page-help-related-header {\n          @extend %font-regular;\n          color: #32363a;\n          padding: 1rem 0rem;\n        }\n        .cald_page-help-content {\n          color: #515559;\n        }\n        .cald_page-help-tool-container {\n          .cald_page-help-tool-content {\n            .cald_page-help-tool-item {\n              cursor: pointer;\n              .cald_page-help-tool-icon {\n                color: #0a6ed1;\n              }\n              .cald_page-help-tool-label {\n                color: #515559;\n                padding: 0rem 1rem;\n              }\n            }\n          }\n        }\n        .cald_page-help-related-container {\n          .cald_page-help-related-content {\n            .cald_page-help-related-link {\n              color: #0a6ed1;\n              padding: 0.4rem 0rem;\n              display: inline-block;\n              cursor: pointer;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .cald_user-profile-option-mask-bar {\n    width: 2.8rem;\n    height: 2.8rem;\n    background-color: #3b4b5b;\n    border: solid 1px #ffffff;\n    border-radius: 50%;\n    display: inline-block;\n    margin: -0.1rem 1rem;\n    .cald_user-profile-option-mask-text-bar {\n      width: 100%;\n      color: #fff;\n      font-size: 1.4rem;\n      font-weight: 300;\n      text-align: center;\n      height: 100%;\n      display: inline-block;\n      line-height: 2.6rem;\n    }\n  }\n\n  .cald_header-dropdown-options {\n    right: 1.2rem !important;\n    left: auto !important;\n    top: 3.5rem !important;\n    &.cc-menu-arrow {\n      top: 1rem;\n    }\n    .cald_user-profile-option {\n      color: blue !important;\n      background-color: #fafafa;\n      cursor: pointer;\n      padding: 0.7rem 1.6rem;\n      .cald_user-profile-option-mask {\n        width: 4.8rem;\n        height: 4.8rem;\n        background-color: #3b4b5b;\n        border: solid 1px #ffffff;\n        border-radius: 50%;\n        display: inline-block;\n        margin-right: 1.2rem;\n        .cald_user-profile-option-mask-text {\n          width: 100%;\n          color: #fff;\n          font-size: 1.8rem;\n          font-weight: 300;\n          text-align: center;\n          height: 100%;\n          display: inline-block;\n          line-height: 4.8rem;\n        }\n      }\n      .cald_user-profile-option-name {\n        display: inline-block;\n        width: 18rem;\n        position: absolute;\n        top: 1.4rem;\n        .cald_user-profile-option-name-text {\n          width: 100%;\n          font-size: 1.8rem;\n          font-weight: 300;\n          color: #32363a;\n        }\n        .cald_user-profile-option-name-group {\n          width: 100%;\n          font-size: 1rem;\n          color: #6f7275;\n        }\n      }\n    }\n    .cald_user-menu-option {\n      font-size: 1.4rem;\n      color: #515559;\n      padding: 0.7rem 2rem;\n      .cald_user-menu-option-option-text {\n        cursor: pointer;\n      }\n    }\n    .cald_user-menu-option-option {\n      border-top: #e5e5e5 0.1rem solid;\n      .cald_logout-btn {\n        margin: 0.5rem;\n        background-color: #0a6ed1;\n        border: 0.1rem solid #367db8;\n      }\n    }\n    .cald_logout-option {\n      font-size: 1.4rem;\n      color: #333333;\n      padding-left: 2rem;\n      padding-top: 0.7rem;\n      .cald_logout-option-text {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .searchbar-container {\n    display: inline-block;\n    position: relative;\n    .divExpandSearch {\n      position: absolute;\n      right: 1rem;\n      top: -0.7rem;\n    }\n    .expandedCls {\n      display: inline-block;\n      width: 30rem;\n    }\n  }\n\n  .fa-th:before {\n    content: '\\f00a';\n    margin-right: 0.8rem;\n  }\n\n  .cald_left {\n    float: left;\n    padding: 2.5rem 0rem 2rem 2rem;\n  }\n\n  .caret {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 0.2rem;\n    vertical-align: middle;\n    border-top: 0.4rem dashed;\n    border-top: 0.4rem solid;\n    border-right: 0.4rem solid transparent;\n    border-left: 0.4rem solid transparent;\n  }\n\n  .cald_logo-container {\n    .cald_header-name-label-container {\n      display: inline-block;\n      color: #32363a;\n      font-size: 1.4rem;\n      position: absolute;\n      top: 1.6rem;\n      left: 6.1rem;\n    }\n  }\n\n  .cald_header-toggle-container {\n    height: 100%;\n    text-align: left;\n    padding: 1.3rem 1rem 1rem;\n    @media (min-width: $screen-sm-min) {\n      max-width: 3rem;\n    }\n    .cald_side-menu-icon {\n      height: 2.6rem;\n      width: 3.2rem;\n      padding: 1rem 0.5rem 0.5rem;\n      cursor: pointer;\n      color: $shell-icon-color;\n      &:hover {\n        border-radius: 0.4rem;\n        background-color: #485b6e;\n      }\n    }\n    .cald_side-menu-icon:before {\n      font-size: 1.8rem;\n    }\n  }\n\n  .logo-icon {\n    background-color: transparent;\n    background-image: url(../../assets/images/vw_header_icon_white.png);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 4.8rem;\n    width: 10rem;\n    display: inline-block;\n    margin-left: 1rem;\n  }\n\n  .logo-icon:focus {\n    outline: none !important;\n  }\n\n  .cald_lang-dropdown {\n    width: 10rem;\n    display: inline-block;\n  }\n\n  .cald_logout {\n    padding-left: 1rem;\n    cursor: pointer;\n  }\n}\n\napp-distributor-search {\n  .common-distributor-search {\n    .side-margin-left {\n      margin: 0 !important;\n    }\n  }\n}\n\n.strip {\n  height: 0.4rem;\n  background-color: #e4e8f0;\n}\n","/* Device breakpoints */\n$screen-xs-max: 767px;\n$screen-sm-min: 768px;\n$screen-sm-max: 991px;\n$screen-md-min: 992px;\n$screen-md-max: 1199px;\n$screen-lg-min: 1200px;","$label-color: #6f7275;\n$label-value: #515559;\n$title-color: #32363a;\n$actions-color: #0a6ed1;\n$bg-color: #edeff0;\n$white: #fff;\n$shell-bg-color: #354a5f;\n$nav-bg-color:#F8F9FA;\n$placeholder-image-bg-color: #eeeeef;\n$text-action-hover-color: #fafafa;\n$text-action-click-color: #eeeeef;\n$active-input-color: #eef5fc;\n$error-color: #ee0000;\n$warning-offline-color: #e9730c;\n$success-color: #118843;\n$input-text-color: #32363a;\n$form-field-disable-color: #fafafa;\n$divider-color: #e5e5e5;\n$warning-bg-color:#fef7f1;\n$danger-color: #bb0000;\n$green-text: #107f3e;\n\n// buttons\n$primary-btn-color: #0a6ed1;\n$primary-btn-hover-color: #085caf;\n$primary-btn-active-color: #0854a1;\n$primary-btn-border-color: #367db8;\n$toggle-down-color: #0854a1;\n$shell-icon-color: #d1e3ff;\n$shell-hover-color: #485b6e;\n$shell-icon-active-color: #919ba7;\n$sidebar-icon-color: #313336;\n\n//Bootstrap5 migration\n$btn-primary-color: #337ab7;\n$btn-primary-active-color: #2e6da4;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
